import React from 'react';
import I18n from '@/modules/i18n';
import Icon from '@/components/ui/Icon';
import Pill from '@/components/ui/Pill';

interface AssignmentTypeChipProps {
  label: string;
  onRemove: () => void;
}

const AssignmentTypeChip = ({ label, onRemove }: AssignmentTypeChipProps) => (
  <Pill pillColor="grey">
    <span className="tw-flex tw-items-center tw-gap-1">
      {label}
      <button
        aria-label={`${I18n.t('remove')} ${label}`}
        className="tw-flex tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer"
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      >
        <Icon icon="Close" size={10} />
      </button>
    </span>
  </Pill>
);

export default AssignmentTypeChip;
